import React, { useContext } from 'react';
// Import context
import { HomeContext } from 'screens/Home/Home';
import './FilterItem.module.scss';

type Props = {
  filterName: string;
  filterId: number;
  active: boolean;
};

export default function FilterItem({ filterName, active, filterId }: Props) {
  const { activeFilters, setActiveFilters } = useContext(HomeContext);

  function handleFilterUpdate() {
    if (activeFilters.includes(filterId)) {
      setActiveFilters((prev) => prev.filter((af) => af !== filterId));
    } else {
      setActiveFilters((prev) => [...prev, filterId]);
    }
  }

  return (
    <div
      onClick={handleFilterUpdate}
      styleName={`filter-item ${active ? 'active' : ''}`}
    >
      {filterName}
      {/* {activeFilters.includes(filterId) ? 'on' : 'off'} */}
    </div>
  );
}
